import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import { Color } from '../../../assets/color';
import { useNavigate } from 'react-router-dom';
import { DeleteSvg, EditSvg, PersonSvg } from '../../../assets/svg';
import RouteHeader from '../../../components/common/RouteHeader';
import DatatableHeading from '../../../components/heading/DatatableHeading';
import DatatableWithSearch from '../../../components/datatable/DatatableWithSearch';
import * as SuperadminActions from '../../../redux/actions/superadminAction';

const Admins = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { adminData } = useSelector(state => state?.superadminReducer);
    const { superadminAdminPartnerDetails } = useSelector((state) => state.authReducer);

    //* Datatable Columns
    const columns = [
        { name: 'S.No.', selector: row => adminData?.indexOf(row) + 1, width: '80px' },
        { name: 'Admin Name', selector: row => row?.admin_name || '...' },
        { name: 'Mobile No.', selector: row => row?.mobile_number || '...' },
        { name: 'Email ID', selector: row => row?.email || '...', width: '250px' },
        { name: 'Password', selector: row => row?.password || '...' },
        { name: 'Wallet Balance', selector: row => row?.report_wallet_balance || '...' },
        { name: 'Status', selector: row => row?.is_active ? 'Active' : 'Inactive' },
        {
            name: 'Action',
            cell: row => (
                <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
                    <div onClick={() => navigate(`/management/admins/partner?name=${row?.admin_name}&id=${row?._id}`)} style={{ cursor: "pointer" }}><PersonSvg /></div>
                    <div onClick={() => navigate('/management/admins/edit-admin', { state: { stateData: row } })} style={{ cursor: "pointer" }}><EditSvg /></div>
                    {/* <div style={{ cursor: "pointer" }}><DeleteSvg /></div> */}
                </div>
            ),
            right: 'true'
        },
    ];

    useEffect(() => {
        //! Dispatching API
        dispatch(SuperadminActions.getAdmins());
    }, []);

    return (
        <>
            <RouteHeader title={`Administrators`} sub_title={`Manage system administrators and their permissions`} url={'/management/admins/add-admin'} url_name={superadminAdminPartnerDetails?.role == 'Superadmin' && 'Add Administrators'} />

            <div style={{ backgroundColor: Color.white, padding: "20px", borderRadius: "10px" }}>
                <Grid container spacing={6} >
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <DatatableHeading title={'Administrators List'} sub_title={'View and manage all system administrators'} />
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <DatatableWithSearch data={adminData} columns={columns} />
                    </Grid>
                </Grid>
            </div>
        </>
    )
}

export default Admins;